import type {
  OrganizationListOptions,
  OrganizationPage,
  OrganizationRepository,
} from '#/domain/organization/OrganizationRepository'

export class GetOrganizationListUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(options: OrganizationListOptions): Promise<OrganizationPage> {
    return this.repository.findAll(options)
  }
}
